import { createReducer, on } from "@ngrx/store";
import { RehydrateOptions } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { CasinoBlockAction } from "./casino-block.action";
import { CasinoBlockState } from "./casino-block.model";

const INITIAL_STATE: CasinoBlockState = {};
const rehydrateOptions: RehydrateOptions<CasinoBlockState> = {
	name: "casinoBlockReducer",
	excludeProps: ["isCasinoBlocked", "isPlayerProfileSelected"],
};

export const casinoBlockReducer = createReducer(
	INITIAL_STATE,
	on(CasinoBlockAction.update, (state, { casinoBlockUpdate }) => updateState(state, casinoBlockUpdate)),
	on(CasinoBlockAction.postpone, (state) => updateState(state, { isSelectionPostponed: true })),
	on(CasinoBlockAction.clear, () => INITIAL_STATE)
);

casinoBlockReducer.prototype.rehydrateOptions = rehydrateOptions;
